import React from 'react'
import { TopicsDetailListContainer } from './styles'
import { DetailsHardRule, DetailsTopicHeading } from '../TopicsDetailComponent/styles'
import TopicBody from '../TopicBody'

const TopicsDetailList = ({
  groupedTopics,
  focusedTopic
}) => (
  <TopicsDetailListContainer data-testid="topics-detail-list">
    {groupedTopics
      .map((topic, idx) => (
        <li key={`${topic.topic}_[sL]${topic.subTopics.length}`}>
          <React.Fragment>
            {idx !== 0 ? <DetailsHardRule /> : null}
            <DetailsTopicHeading
              data-topic={topic.topic}
              id={topic.topic}
              className={
                focusedTopic === topic.topic ? 'activeContent' : null
              }
            >
              {topic.topic}
            </DetailsTopicHeading>
          </React.Fragment>
          <TopicBody
            {...{ topic, idx }}
          />
        </li>
      ))}
  </TopicsDetailListContainer>
)

export default TopicsDetailList
